
import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosInstance";
import Header from "../../header";
import InstructorSidebar from "../sidebar";
import { AppContext } from "../../../services/AuthContext";
import { Link } from "react-router-dom";

const SubscriptionList = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { auth } = useContext(AppContext);
  const token = auth.token;

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await axiosInstance.get(
          "http://89.163.221.52:8080/idealonline/v1/librarypanel/InstutationSubscriptionpackageList/1",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSubscriptions(response.data.data || []);
      } catch (error) {
        console.error("Abonelik verisi alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, []);

  return (
    <div className="main-wrapper mt-5">
      <Header />
      <>
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">Abonelik Paketleri</h2>
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">Ana Sayfa</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Abonelik Paketleri
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <InstructorSidebar />

            <div className="col-xl-9 col-lg-9">
              <div className="settings-widget card-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Abonelik Paketleri</h3>
                  </div>
                  {loading ? (
                    <p>Yükleniyor...</p>
                  ) : (
                    <div className="table-responsive custom-table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Paket Adı</th>
                            <th>Başlangıç</th>
                            <th>Bitiş</th>
                            <th>Kullanıcı Limiti</th>
                            <th>Durum</th>
                          </tr>
                        </thead>
                        <tbody>
                          {subscriptions.map((item) => (
                            <tr key={item.id}>
                              <td>{item.subscriptionpackage?.name}</td>
                              <td>
                                {new Date(item.startdate).toLocaleDateString()}
                              </td>
                              <td>
                                {new Date(item.enddate).toLocaleDateString()}
                              </td>
                              <td>
                                {item.subscriptionpackage?.nameduserlimit ??
                                  "-"}
                              </td>
                              <td>
                                {item.status === 1 ? (
                                  <span className="badge bg-success">
                                    Aktif
                                  </span>
                                ) : (
                                  <span className="badge bg-secondary">
                                    Pasif
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                          {subscriptions.length === 0 && (
                            <tr>
                              <td colSpan="5">Abonelik bulunamadı.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionList;
